if (!customElements.get('collection-grid-toggle')) {
  class CollectionGridToggle extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.storageKey = this.dataset.storageKey || 'collection-grid-cols';
      this.defaultCols = this.getAttribute('data-cols') || '4';
      this.collection = this.closest('.collection');

      this.cols = this.defaultCols;
      if (!(window.Shopify && window.Shopify.designMode)) {
        try {
          const saved = JSON.parse(localStorage.getItem(this.storageKey) || 'null');
          if (saved && saved.base === this.defaultCols && (saved.cols === '3' || saved.cols === '4')) {
            this.cols = saved.cols;
          }
        } catch (e) {
          /* storage unavailable */
        }
      }
      this.apply();

      if (this.button) {
        this.button.addEventListener('click', () => {
          this.cols = this.cols === '4' ? '3' : '4';
          try {
            localStorage.setItem(this.storageKey, JSON.stringify({ cols: this.cols, base: this.defaultCols }));
          } catch (e) {
            /* storage unavailable */
          }
          this.apply();
        });
      }
    }

    apply() {
      this.setAttribute('data-cols', this.cols);
      if (this.button) {
        this.button.setAttribute('aria-pressed', this.cols === '3' ? 'true' : 'false');
      }
      if (this.collection) {
        if (this.cols === this.defaultCols) {
          this.collection.style.removeProperty('--products_per_row');
        } else {
          this.collection.style.setProperty('--products_per_row', this.cols);
        }
      }
    }
  }

  customElements.define('collection-grid-toggle', CollectionGridToggle);
}
